<template>
  <div class="all-in-animation">
    <img class="light" src="../img/light.avif">
    <img class="text1" src="../img//allin1.avif" alt="">
    <img class="text2" src="../img//allin2.avif" alt="">
    <img class="coins" src="../img/coins.webp" alt="all in coins" />
    <img class="coins2" src="../img/coins2.webp" alt="">
    <template v-if="showHand">
      <img class="hand hand-1" src="../img/hand1.webp" alt="hand" />
      <img class="hand hand-2" src="../img/hand2.webp" alt="hand" />
    </template>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  showHand: boolean
}>();
</script>

<style scoped lang="scss">
.all-in-animation {
  position: absolute;
  inset: 0;
  z-index: 12;
  pointer-events: none;
  overflow: hidden;
}

.coins {
  position: absolute;
  left: 50%;
  top: 50%;
  width: min(58vw, 360px);
  transform: translate(-50%, -50%) scale(0.35);
  opacity: 0;
  transform-origin: center;
  animation: coins-enter 0.5s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
}
.coins2 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  animation:
    coins2-show 0s linear 0.5s forwards,
    coins2-hide 0s linear 1s forwards;
}
.light {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  animation:
    light-show 0s linear 0.5s forwards,
    light-spin 4s linear 0.5s infinite;
}
.hand {
  position: absolute;
  bottom: -40px;
  opacity: 0;
}

.hand-1 {
  animation:
    hand-enter 0.5s cubic-bezier(0.15, 0.85, 0.2, 1) forwards,
    hand-hide 0s linear 0.5s forwards;
}

.hand-2 {
  animation: hand-enter 0.5s cubic-bezier(0.15, 0.85, 0.2, 1) 0.5s forwards;
}

.text1 {
  position: absolute;
  left: 50%;
  top: 15%;
  transform: translateX(-50%);
  opacity: 0;
  animation:
    text1-show 0s linear 0.2s forwards,
    text1-hide 0s linear 0.5s forwards;
}
.text2 {
  position: absolute;
  left: 50%;
  top: 5%;
  transform: translateX(-50%);
  z-index: 3;
  opacity: 0;
  animation: text2-show 0s linear 0.7s forwards;
}
@keyframes coins-enter {
  0% {
    transform: translate(-50%, -50%) scale(0.35);
    opacity: 0;
  }
  70% {
    transform: translate(-50%, -50%) scale(0.98);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}

@keyframes hand-enter {
  0% {
    transform: translateY(120%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes hand-hide {
  to {
    transform: translateY(120%);
    opacity: 0;
  }
}

@keyframes coins2-show {
  to {
    opacity: 1;
  }
}

@keyframes coins2-hide {
  to {
    opacity: 0;
  }
}

@keyframes light-show {
  to {
    opacity: 1;
  }
}

@keyframes light-spin {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes text1-show {
  to {
    opacity: 1;
  }
}

@keyframes text1-hide {
  to {
    opacity: 0;
  }
}

@keyframes text2-show {
  to {
    opacity: 1;
  }
}
</style>